import { motion } from 'framer-motion';

const Contact = () => {
  const contactMethods = [
    {
      label: "EMAIL",
      value: "chaddix@currentresident.tv",
      link: "mailto:chaddix@currentresident.tv"
    },
    {
      label: "PHONE", 
      value: "+1 (715) 338-1198",
      link: "tel:+17153381198"
    },
    {
      label: "LOCATION",
      value: "Minneapolis, MN",
      link: "https://www.google.com/maps/place/Minneapolis,+MN"
    }
  ];

  return (
    <div className="h-screen text-white bg-transparent overflow-hidden md:overflow-hidden overflow-y-auto">
      {/* Main Section */}
      <section className="h-full py-8 lg:py-30 px-4 sm:px-6 lg:px-8 flex items-center pb-24 pt-24">
        <div className="max-w-5xl mx-auto w-full">
          
          {/* Main Header */}
          <motion.div
            className="mb-12 lg:mb-20"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            {/* Brutalist Header Block */}
            <div className="relative">
              <div className="absolute top-4 left-4 w-full h-full bg-white/10"></div>
              <div className="relative bg-black border-4 border-white p-8 lg:p-12 transform -rotate-1 mt-6">
                <h1 style={{ fontSize: 'clamp(2.5rem, 8vw, 6rem)' }} className="font-black uppercase leading-none">
                  CHEERS
                </h1>
                <div className="w-20 lg:w-32 h-2 bg-white mt-4"></div>
              </div>
            </div>
          </motion.div>

          {/* Contact Grid */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12">
            {contactMethods.map((contact, index) => (
              <motion.a
                key={index}
                href={contact.link}
                target={contact.link.startsWith('http') ? '_blank' : '_self'}
                rel={contact.link.startsWith('http') ? 'noopener noreferrer' : ''}
                className="group block"
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
              >
                <div className="relative h-full">
                  {/* Background shadow block */}
                  <div className="absolute top-3 left-3 w-full h-full bg-white"></div>
                  
                  {/* Main content block */}
                  <div className="relative bg-black border-4 border-white p-6 lg:p-8 h-full group-hover:transform group-hover:-translate-x-2 group-hover:-translate-y-2 transition-transform duration-200">
                    
                    {/* Geometric icon replacement */}
                    <div className="mb-6">
                      <div className="flex gap-2">
                        <div className="w-4 h-4 bg-white"></div>
                        <div className="w-4 h-4 bg-white/60"></div>
                        <div className="w-4 h-4 bg-white/30"></div>
                      </div>
                    </div>
                    
                    {/* Label */}
                    <div className="bg-white text-black p-3 mb-4 border-2 border-white transform rotate-1">
                      <h3 style={{ fontSize: 'clamp(1rem, 1.5vw, 1.25rem)' }} className="font-black uppercase tracking-wider">
                        {contact.label}
                      </h3>
                    </div>
                    
                    {/* Value */}
                    <p style={{ fontSize: 'clamp(0.875rem, 1.2vw, 1rem)' }} className="text-white font-medium leading-tight group-hover:text-gray-100 transition-colors">
                      {contact.value}
                    </p>
                    
                    {/* Bottom accent */}
                    <div className="absolute bottom-4 right-4">
                      <div className="w-8 h-8 border-2 border-white/30 transform rotate-45"></div>
                    </div>
                  </div>
                </div>
              </motion.a>
            ))}
          </div>

          {/* Bottom Geometric Element */}
          <motion.div
            className="mt-16 lg:mt-24 flex justify-center"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
          >
            <div className="flex gap-4">
              <div className="w-16 h-2 bg-white"></div>
              <div className="w-16 h-2 bg-white/60"></div>
              <div className="w-16 h-2 bg-white/30"></div>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default Contact; 